import Cookies from 'js-cookie';
const pathname = location.pathname;
const queryStr = location.search;
const cookies = document.cookie;
const parsedCookies = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
cookies.split(/\s*;\s*/).forEach((pair) => {
    pair = pair.split(/\s*=\s*/);
    const name = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair.splice(1).join('='));
    parsedCookies[name] = value;
});
const checkIfSuppPage = () => {
    const pages = [
        'accident-expense-insurance',
        'cancer-insurance',
        'heart-stroke-insurance',
        'whole-life-insurance',
        'cancer-treatment-insurance',
        'hospital-indemnity-insurance',
    ];
    return pages.find((e) => pathname.includes(e)) || '';
};
const getOrgFromPath = (phoneString = false) => {
    if (pathname.match(/(medicare)/gm)) {
        return phoneString ? 'medSuppPhone' : 'medSuppCampaign';
    }
    else if (pathname.match(/(supplemental|csb)/gm)) {
        return phoneString ? 'csbSuppPhone' : 'csbSuppCampaign';
    }
    else if (pathname.match(/(dental)/gm)) {
        return phoneString ? 'ifpDenPhone' : 'ifpDenCampaign';
    }
    else {
        return phoneString ? 'ifpMedPhone' : 'ifpMedCampaign';
    }
};
const setCampaignPhoneCookie = (campaignObj, isAlreadySet = false) => {
    const valueToUse = (type) => (isAlreadySet ? Cookies.get(type) : campaignObj[type]);
    const currentOrg = getOrgFromPath(true);
    const updatedPhone = valueToUse(currentOrg) && valueToUse(currentOrg) !== '0' ? valueToUse(currentOrg) : '';
    campaignObj.campaignPhone = updatedPhone;
    if (isAlreadySet || !updatedPhone.length) {
        Cookies.set('campaignPhone', updatedPhone);
    }
    return campaignObj;
};
const checkIfCookieExists = (cookieToCheck, cookiePhoneToCheck) => (Object.prototype.hasOwnProperty.call(parsedCookies, cookieToCheck) && parsedCookies[cookieToCheck].length) > 0 &&
    Object.prototype.hasOwnProperty.call(parsedCookies, cookiePhoneToCheck) &&
    parsedCookies[cookiePhoneToCheck] !== 'undefined';
const preventCampaignsCall = (override = false) => {
    const currentOrg = getOrgFromPath();
    const currentOrgPhone = getOrgFromPath(true);
    if (override)
        return !override;
    if ((queryStr.length > 0 && queryStr !== '?campaign_ID=CSBORG' && queryStr.includes('campaign')) || checkIfSuppPage().length) {
        return false;
    }
    return checkIfCookieExists(currentOrg, currentOrgPhone);
};
export class CampaignsService {
    constructor(gateway, logger) {
        this.gateway = gateway;
        this.logger = logger;
    }
    async getCampaignsInfo(override = false) {
        var _a;
        if (preventCampaignsCall(override))
            return setCampaignPhoneCookie(parsedCookies, true);
        let results = {};
        try {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const url = new URL(this.gateway);
            const response = await fetch(url.toString(), {
                method: 'POST',
                body: JSON.stringify({
                    cookies: parsedCookies,
                    params: location.search,
                    pathname,
                    referrer: document.referrer,
                }),
            });
            results = await response.json();
            results = setCampaignPhoneCookie(results);
            for (const cookie in results) {
                if (results[cookie] && results[cookie].length) {
                    Cookies.set(cookie, results[cookie], { expires: 30 });
                }
            }
        }
        catch (error) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error(error);
        }
        return results;
    }
}
//# sourceMappingURL=service.js.map